export default __webpack_public_path__ + "static/media/wichtigsten_infos_zum_gutschein.9716c370.svg";